// WeddingCountdown.jsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const CountdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const TimeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: end;
  font-family: var(--text-normal);
  min-height: 46px;

  span:first-child {
    font-size: 2.5rem;
    font-weight: bold;
  }

  span:last-child {
    font-size: 1rem;
    text-transform: uppercase;
    margin-top: auto;
  }
`;

const Message = styled.p`
  margin-bottom: 2rem;
  font-family: var(--text-cursive);
  font-size: 2rem;
`;

const DateSection = styled.div`
  width: 300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 2rem;
`;

const DateItem = styled.div`
  text-align: center;
  font-size: 1.2rem;
  // border top and bottom
  border-top: 1.75px solid var(--text);
  border-bottom: 1.75px solid var(--text);
  padding: 0.5rem 0;

  &:nth-child(2) {
    font-size: 3rem;
    font-weight: bold;
    border: none;
  }

  opacity: 0.7;
`;

const Countdown = () => {
  const targetDate = new Date(new Date('2025-12-13T12:00:00').toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
  const [timeLeft, setTimeLeft] = useState({});
  const [hasPassed, setHasPassed] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      // Obtener fecha/hora de Madrid
      const nowMadrid = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));

      const diff = targetDate - nowMadrid;

      if (diff <= 0) {
        setHasPassed(true);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setHasPassed(false);
      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <>
      {/* <h2>FALTAN:</h2> */}
      {hasPassed ? (
        <Message>Gracias por acompañarnos en este día tan especial 💍</Message>
      ) : (
        <>
          <CountdownWrapper>
            <TimeBox>
              <span>{timeLeft.days}</span>
              <span>Días</span>
            </TimeBox>
            <TimeBox>
              <span>{timeLeft.hours}</span>
              <span>Horas</span>
            </TimeBox>
            <TimeBox>
              <span>{timeLeft.minutes}</span>
              <span>Minutos</span>
            </TimeBox>
            <TimeBox>
              <span>{timeLeft.seconds}</span>
              <span>Segundos</span>
            </TimeBox>
          </CountdownWrapper>

          <Message>¡Queremos celebrar contigo este día tan especial!</Message>
        </>
      )}

      <DateSection>
        <DateItem>SÁBADO</DateItem>
        <DateItem className="number">13</DateItem>
        <DateItem>DICIEMBRE</DateItem>
      </DateSection>
    </>
  );
};

export default Countdown;
